module.exports = __webpack_public_path__ + "img/eye.95abd877.svg";